export default __webpack_public_path__ + "static/white-wordmark-bacdf06d134142119a0064961ae00053.svg";